<template lang="html">
  <div
    @mouseover="hover = true"
    @mouseleave="hover = false"
    class="item-wrapper"
  >
    <item-image
      :itemImage="getItemImage"
      :hover="hover"
      :favorite="getFavorite"
      :id="itemData.pro_id"
      @details="openDetails"
      :myProduct="getMyProduct"
    />
    <item-description
      :description="itemData"
      :hover="hover"
      @details="openDetails"
    />
    <button class="btn dark item-btn" @click="openDetails">
      {{ $t("main.viewProduct") }}
      <img src="../../assets/newImges/arrowUpRight.svg" alt="go" />
    </button>
  </div>
</template>

<script>
import { baseURL } from "@/api";
import ItemDescription from "@/components/item/itemDescription.vue";
import ItemImage from "@/components/item/itemImage.vue";
export default {
  name: "item",
  props: {
    itemData: {
      required: true,
      type: Object
    }
  },
  components: {
    ItemDescription,
    ItemImage
  },
  data() {
    return {
      hover: false
    };
  },
  activated() {
    this.hover = false;
  },
  computed: {
    getItemImage() {
      if (this.itemData.pro_image) {
        return baseURL + this.itemData.pro_image;
      } else {
        return require("@/assets/images/defaultItemImage.png");
      }
    },
    getFavorite() {
      return this.itemData.favorite === 1;
    },
    getMyProduct() {
      return this.itemData.my_product === 1;
    }
  },
  methods: {
    openDetails() {
      let params = Object.assign({}, this.$route.params);
      params.id = this.itemData.pro_id;
      this.$router.push({ name: "Details", params: params });
    }
  }
};
</script>

<style lang="scss" scoped>
.item-wrapper {
  margin: 5px;
  margin-right: 30px;
  max-width: 427px;
  // max-height: 1033px;
  height: 900px;
  background: $gray-blue-100;
  border: 1px solid $gray-blue-500;
  box-shadow: 0px 3px 6px #0000000f;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 31px 42px;
  display: flex;
  flex-direction: column;
}
.item-wrapper:last-child {
  margin-right: 0px;
}
.item-btn {
  margin-top: auto;
  width: 236px;
  border-radius: 12px;
}

@media only screen and (max-width: 768px) {
  .item-wrapper {
    margin: 0px;
    width: 100%;
    min-width: 300px;
    padding: 8px 5px;
    box-shadow: 0px 3px 6px transparent;
    height: fit-content;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-right: 16px;
  }
  .item-btn {
    display: none;
  }
}
@media only screen and (max-width: 330px) {
  .item-wrapper {
    margin: 0px;
    width: 100%;
    min-width: calc(100vw - 20px);
    padding: 8px 5px;
  }
}
</style>
